import { render, staticRenderFns } from "./PlatformsOpenWidget.vue?vue&type=template&id=794257ea"
import script from "./PlatformsOpenWidget.vue?vue&type=script&lang=js"
export * from "./PlatformsOpenWidget.vue?vue&type=script&lang=js"
import style0 from "./PlatformsOpenWidget.vue?vue&type=style&index=0&id=794257ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports